//项目菜单驱动全量映射表
export const routerDrive = {
  'GOVP_TENDER_PROJECT_APPROVAL': 'project-approval-list', //项目入场登记核验
  'GOVP_TENDER_PROJECT_VIEW': 'project-info', //项目概况
  'GOVP_SINGLE_SOURCE_NOTICE': 'single-source-notice-main', //单一来源公示

  'GP_BID_PURCHASE_BULLETIN_FILING_MODULE': 'procrement-file-detail', //采购公告及文件编制
  'GP_AUDIT_NOTICE_FILING_MODULE': 'procrement-file-detail-review', //资审公告及文件编制
  'GP_BID_PURCHASE_BULLETIN_FILING_CONTEST_MODULE': 'procrement-file-detail', //谈判公告及文件编制
  'GP_BID_PURCHASE_BULLETIN_FILING_COMPETITION_MODULE': 'procrement-file-detail', //磋商公告及文件编制
  'GP_BID_PURCHASE_BULLETIN_FILING_INQUIRY_MODULE': 'procrement-file-detail', //询价公告及文件编制
  'GP_BID_PURCHASE_BULLETIN_FILING_SINGLE_SOURCE_MODULE': 'procrement-file-detail', //单一来源公告及文件编制
  'GOVP_BID_OFFER': 'price-form-list', //报价形式设置
  'GP_BID_INVITATION_FILING_MODULE': 'procrement-file-detail-invitation-list', //邀请书及文件编制
  'GP_BID_INVITATION_FILING_CONTEST_MODULE': 'procrement-file-detail-invitation-list', //（竞谈）邀请书及文件编制
  'GP_BID_INVITATION_FILING_COMPETITION_MODULE': 'procrement-file-detail-invitation-list', //（竞磋）邀请书及文件编制
  'GP_BID_INVITATION_FILING_INQUIRY_MODULE': 'procrement-file-detail-invitation-list', //（询价）邀请书及文件编制
  'GP_BID_INVITATION_FILING_SINGLE_SOURCE_MODULE': 'procrement-file-detail-invitation-list', //（单一来源）邀请书及文件编制
  'GP_BID_INVITATION_FILING_QUALIFICATION_AUDIT_MODULE': 'procrement-file-detail-invitation-list', //（预审）邀请书及文件编制

  'GOVP_QUALIFICATION_AUDIT_NOTICE': 'qualification-audit-detail',
  'GOVP_QUALIFICATION_AUDIT_NOTICE_MODIFY': 'qualification-audit-notice-modify-list', //资审更正公告
  'GOVP_PROCREMENT_FILE_AND_NOTICE_CONTEST': 'procrement-file-detail-contest', //采购公告及文件(竞谈)
  'GOVP_PROCREMENT_FILE_AND_NOTICE_COMPETITION': 'procrement-file-detail-competition', //竞磋文件编制
  'GOVP_PROCREMENT_FILE_COMPETITION_INVITATION': 'procrement-file-detail-competition-invitation', //磋商邀请书编制
  'GOVP_PROCREMENT_FILE_INQUIRY': 'procrement-file-detail-inquiry', //询价文件编制
  'GOVP_PROCREMENT_FILE_INQUIRY_INVITATION': 'procrement-file-detail-inquiry-invitation', //询价邀请书编制
  'GOVP_PROCREMENT_FILE_ONE_SOURCE': 'procrement-file-detail-onsource', //单一来源，谈判邀请书
  'GOVP_PROCREMENT_FILE_AND_NOTICE_CONTEST_INVITATION': 'procrement-notice-contest-invitation', //谈判邀请书
  'GOVP_PROCREMENT_FILE_INVITATION_PRETRIAL': 'procrement-notice-invitation-pretrial-list', //邀请预审采购公告
  'GOVP_PROCREMENT_FILE_INVITATION_TWO_ENVELOPE': 'procrement-notice-invitation-two-envelope',
  'GOVP_MODIFY_NOTICE': 'modify-notice-list', //信息更正公告-公开
  'GOVP_MODIFY_NOTICE_INVITE': 'modify-notice-invite-list', //信息更正公告-邀请
  'GOVP_MODIFY_NOTICE_CONTEST': 'modify-notice-contest-list', //信息更正公告-竞谈
  'GOVP_MODIFY_NOTICE_INQUIRY': 'modify-notice-inquiry-list', //信息更正公告-询价
  'GOVP_MODIFY_NOTICE_COMPETITION': 'modify-notice-competition-list', //信息更正公告-竞磋
  'GOVP_MODIFY_NOTICE_ONESOURCE': 'modify-notice-onesource-list', //信息更正公告-单一来源
  'GOVP_REVIEW_EXPERT_REGISTRATION': 'review-expert-registration-list', //评审专家登记
  'GOVP_OPEN_BID_RESULT': 'open-bid-result-list', //开标结果记录
  'GOVP_EVAL_QUALIFICATIONAUDIT': 'qualification-audit-record-list', //资审结果登记
  'GOVP_EVAL_QUALIFICATIONAUDIT_INVITE': 'qualification-audit-record-list', //资审结果登记
  'GOVP_EVALUATION_RESULT': 'evaluation-bid-result-list', //评审结果登记
  'GOVP_WIN_BID_ANNOUNCEMENT': 'win-bid-announcement-list', //中标结果公告
  'GOVP_CONTRACT_PUBLICITY': 'contract-publicity-list', //合同公示列表页面
  'GOVP_ENROLL_VIEW': 'enroll-view-list', //查看报名情况
  'GOVP_RECOMMENDED_SUPPLIER': 'recommended-supplier-edit', //采购人推荐供应商
  'GOVP_ENROLL_VIEW_INVITE': 'enroll-view-list', //查看报名情况
  'GOVP_SURVEY_RESULT_RECORD': 'survey-result-record-list', //踏勘结果登记
  'GOVP_WIN_BID_NOTICE_MODIFY': 'win-bid-notice-modify-list', //标后结果更正
  'GOVP_EVAL_REACCREDITATION_APPLY': 'reaccreditation-apply-list', //复评申请
  'GOVP_EVAL_REACCREDITATION_CONCLUSION': 'reaccreditation-conclusion-list', //复评结果
  'GOVP_PROJECT_ARGUMENTATION': 'project-arguement-first', //项目论证
  'GOVP_BID_ANSWER': 'answer-project-list', //质疑回复-项目负责人
  'GOVP_NULLIFIELD_BID': 'nullifield-bid-list', //废标公告
  'GOVP_CHANGE_JUDGE_APPLICATION': 'change-judge-application-list', //变更评委申请
  'GOVP_CHANGE_PURCHASER_MODE': 'change-purchaser-mode-list', //变更采购方式
  'GOVP_TENDER_VENUE_BOOK': 'project-venue-book-venue', //预约场地
  'GP_MODULE_VENUE_BOOK': 'venue-book', //预约场地及变更
  'GP_MODULE_ZS_VENUE_BOOK': 'venue-book-review', //资审预约场地及变更
  //'GOVP_PROJECT_FILED':'project-filed-edit',//项目归档旧的
  'GOVP_PROJECT_FILED': 'project-filed-main',//新项目归档
  'GOVP_COLLECTION_DEL_UPLOAD': 'purchase-file-verification-edit',//采购文件编辑
  'GOVP_QUALIFICATION_DEL_UPLOAD': 'information-file-verification-edit',//资审文件编辑
  'GOVP_MODULE_ANNOUNCEMENT_CANCLE_EDIT': 'project-notice-list',//无效中标公告编制
  'GOVP_RE_EVAL_QUALIFICATIONAUDITMODULE_CODE': 're-qualification-audit-record-list', //复评资审结果列表

}

//政府采购对接个人工作台页面路由映射表
export const workbechDrive = {
  // 业务办理Start
  // 业务办理-采购人
  'GOVP_PURCHASE_NOTICE_APPLY': 'notice-apply-list', //单一来源采购公示申请列表
  'GOVP_QUALIFICATION_AUDIT_CORRECTION': 'qualification-audit-correction-list', //资审更正申请
  'GOVP_PROJECT_CORRECTION': 'project-correction-list', //项目更正申请
  'GOVP_EXCEPTION_PURCHASER_PROJECT_STOP': 'purchaser-project-stop-list', //采购人发起的项目异常处理
  'GOVP_PURCHASER_EXCEPTION_PROJECT': 'purchaser-project-pause-resumed-list', //项目暂停处理-采购人发起
  //业务办理-标前项目负责人
  'GOVP_TENDER_CARRY_OUT_NOTICE_ASSIGN_CONFIRM': 'carry-out-notice-assign-confirm-list', //执行通知书任务分派确认
  //业务办理-标后项目负责人
  'GOVP_PROJECT_ASSIGN_CONFIRM': 'project-assign-confirm-list', //标中任务分派确认
  //【代理和项目负责人公有模块】
  'GP_AGENCY_AGREEMENT_AGENT_MODULE': 'agency-agreement-list-agency', //委托代理协议-代理
  'GOVP_TENDER_PURCHASEDEMAND_CONFIRM': 'purchase-demand-confirm-list', //采购需求确认-代理
  'GOVP_PURCHASE_DEMAND_NOTICE': 'purchase-demand-notice-list', //采购需求公示编制-代理
  'GOVP_TENDER_PROJECT': 'project-list', //项目进场登记-代理
  'GOVP_TENDER_PROJECT_NO_PALN': 'project-list-nodemand', //项目进场登记（无采购计划）
  'GOVP_TENDER_PURCHASER_PROJECT_MANAGEMENT': 'purchaser-project-management-list', //我的采购项目
  'GOVP_EXCEPTION_PROJECT_PAUSE': 'project-pause-resumed-list', //项目暂停处理
  'GP_MODULE_GUARANTEE_LETTER_RETURN': 'return-guarantee-list', //退还投标保函
  'GP_MODULE_GUARANTEE_LETTER_RETURN_VIEW': 'check-return-list', //查看退还
  'GP_MODULE_APPROVAL_GUARANTEE_LETTER_RETURN': "return-guarantee-approval-list", //退还投标保函核验
  'GOVP_EXCEPTION_PROJECT_STOP': 'project-stop-list', //项目异常处理
  'GOVP_PROJECT_FILING': 'project-filing-list', //项目备案申请
  'GP_MODULE_ENTRUST_AGENCY_AGREEMENT': "agency-agreement-list",//采购人委托代理协议
  //集采领导+中心核验人员
  'GOVP_TENDER_CARRY_OUT_NOTICE_ACCEPTANCE': 'carry-out-notice-acceptance-list', //采购计划受理-代理+集采领导
  'GOVP_TENDER_CARRY_OUT_NOTICE_ASSIGN': 'carry-out-notice-assign-list', //标前任务分派
  'GOVP_TENDER_CARRY_OUT_NOTICE_DE_ASSIGN': 'carry-out-notice-de-assign-list', //执行通知书任务分派
  'GOVP_PROJECT_DISTRIBUTION': 'distribution-list', //执行通知书任务分派
  'GOVP_PURCHASE_DEMAND_NOTICE_APPROVAL': 'purchase-demand-notice-approval-list', //采购需求公示核验
  'GOVP_SINGLE_SOURCE_NOTICE_APPROVAL': 'single-source-notice-approval-list', //单一来源公示核验列表
  'GOVP_TENDER_PROJECT_APPROVAL': 'project-approval-list', //项目进场登记核验
  'GP_MODULE_APPROVAL_VENUE_BOOK': 'venue-book-approval', //预约场地及变更核验
  'GP_MODULE_ZS_APPROVAL_VENUE_BOOK': 'venue-book-review-approval', //资审预约场地及变更核验
  'GP_AUDIT_NOTICE_FILING_APPROVAL_MODULE': "procrement-file-review-approval-list", //资审公告及文件编制核验
  'GP_BID_PURCHASE_BULLETIN_FILING_APPROVAL_MODULE': "purchase-file-approval-list", //采购公告及文件编制核验
  'GP_BID_INVITATION_FILING_APPROVAL_MODULE': "procrement-file-invitation-approval-list", //邀请书及文件编制核验
  'GOVP_QUALIFICATION_AUDIT_MODIFY_APPROVE': 'qualification-audit-modify-notice-approve-list', //资审更正公告核验
  'GOVP_MODIFY_NOTICE_APPROVE': 'modify-notice-approve-list', //信息更正公告核验
  'GB_MODULE_CONTRACT_EDIT': 'organization-check',//在线合同核验
  'GOVP_PROJECT_ASSIGN': 'project-assign-list', //标中任务分派
  'GOVP_CHANGE_JUDGE_APPLICATION_APPROVE': 'change-judge-application-approve-list', //变更评委申请核验
  'GOVP_EVAL_REACCREDITATION_APPLY_APPROVAL': 'reaccreditation-apply-approval-list', //复评申请核验
  'GOVP_WIN_BID_NOTICE_APPROVE': 'win-bid-announcement-approve-list', //中标结果公告核验
  'GOVP_EVALUATION_BID_RESULT_APPROVE': 'evaluation-bid-result-approve-list',//评审结果核验
  'GOVP_WIN_BID_NOTICE_APPROVE_MODIFY': 'win-bid-notice-modify-approve-list', //标后结果更正核验
  'GP_MODULE_PROJECT_APPROVE_DYNAMIC_ASSIGN': 'project-approve-assign-list', //工作分派
  'GOVP_NULLIFIELD_BID_APPROVAL': 'nullifield-bid-approval-list', //废标公告核验
  'GOVP_EXCEPTION_PROJECT_STOP_APPROVAL': 'project-stop-approval-list', //项目异常处理核验
  'GOVP_EXCEPTION_PROJECT_PAUSE_APPROVAL': 'project-pause-resumed-approval-list', //项目暂停核验处理



  'GOVP_COMPLAINT_ANSWER': 'complaint-answer-list', //投诉处理-监管
  'GOVP_CHANGE_PURCHASER_MODE_APPROVE': 'change-purchaser-mode-approve-list', //变更采购方式核验-监管

  //待办事项
  'GOVP_TENDER_PURCHASEDEMAND': 'purchase-demand-list', //采购需求编制
  'GOVP_PURCHASE_DEMAND_ANSWER': 'purchase-demand-answer-list', //采购需求答疑
  'GOVP_AGENCY_AGREEMENT': 'agency-agreement-list', //委托代理协议
  // 'GOVP_PURCHASE_NOTICE_APPLY':'notice-apply-list',//单一来源采购公示申请列表
  'GOVP_RECOMMENDED_SUPPLIER': 'recommended-supplier-list', //采购人推荐供应商
  // 'GP_AUDIT_NOTICE_FILING_APPROVAL_MODULE':"procrement-file-review-approval-list",//资审公告及文件编制核验
  //'GP_BID_PURCHASE_BULLETIN_FILING_APPROVAL_MODULE':"purchase-file-approval-list",//采购公告及文件编制核验
  // 'GP_BID_INVITATION_FILING_APPROVAL_MODULE':"procrement-file-invitation-approval-list",//邀请书及文件编制核验
  'GOVP_ANSWER': 'answer-list', //质疑回复
  'GOVP_ENPERT_APPLICATION': 'enpert-application-list', //enpert-application-list
  'GOVP_CONFIRM_WIN-BIDDER': 'confirm-win-bidder-list', //确定中标人
  'GOVP_CONTRACT_PUBLICITY-CGR': 'contract-publicity-cgr-list', //合同公示
  'GOVP_IMPLEMENTATION': 'implementation-list', //implementation-list
  "EVAL_UATE_SUPPLIERS": 'evaluate-suppliers',
  "GOVP_MODULE_BIDIRECTEVALUATION_EDIT": 'interested-parties',//相关方互评
}

//全量导航映射表
export const routerMenu = {
  'GP_MODULE_ENTRUST_AGENCY_AGREEMENT_CHECK': "agency-agreement-list-check",//委托代理协议核验
  'GP_MODULE_ENTRUST_AGENCY_AGREEMENT': "agency-agreement-list",//采购人委托代理协议
  'GP_MODUL_VIEW_ENTRUST_AGENCY_AGREEMENT': "agency-agreement-list-jzr",//见证人委托代理协议
  "EVAL_UATE_SUPPLIERS": 'evaluate-suppliers',//评价供应商
  "EVAL_UATE_PURCHASER": 'evaluate-purchaser',//评价采购人
  "GOVP_MODULE_BIDIRECTEVALUATION_EDIT": 'interested-parties',//相关方互评
  'GOVP_FILED_TYPE': 'filed-type-list', //
  'GOVP_FILED_NODE': 'filed-node-list', //
  'GP_AGENCY_AGREEMENT_PURCHASER_MODULE': 'agency-agreement-list', //委托代理协议-采购人
  'GP_AGENCY_AGREEMENT_AGENT_MODULE': 'agency-agreement-list-agency', //委托代理协议-代理
  'GOVP_TENDER_PURCHASEDEMAND': 'purchase-demand-list', //采购需求编制
  'GOVP_PURCHASE_DEMAND_NOTICE': 'purchase-demand-notice-list', //采购需求公示编制
  'GOVP_TENDER_CARRY_OUT_NOTICE': 'carry-out-notice-list', //执行通知书管理
  'GOVP_TENDER_CARRY_OUT_NOTICE_ACCEPTANCE': 'carry-out-notice-acceptance-list', //执行通知书受理
  'GOVP_TENDER_CARRY_OUT_NOTICE_ASSIGN': 'carry-out-notice-assign-list', //执行通知书任务分派
  'GOVP_TENDER_CARRY_OUT_NOTICE_DE_ASSIGN': 'carry-out-notice-de-assign-list', //执行通知书任务分派
  'GOVP_PROJECT_DISTRIBUTION': 'distribution-list', //执行通知书任务分派
  'GOVP_TENDER_CARRY_OUT_NOTICE_READ': 'carry-out-notice-read-list', //采购计划查阅
  'GOVP_TENDER_PURCHASEDEMAND_CONFIRM': 'purchase-demand-confirm-list', //采购需求确认
  'GOVP_PROCREMENT_FILE_APPROVAL': 'procrement-file-approval-list', //产品的-采购公告及文件核验
  'GP_BID_PURCHASE_BULLETIN_FILING_APPROVAL_MODULE': "purchase-file-approval-list", //采购公告及文件编制核验
  'GP_BID_INVITATION_FILING_APPROVAL_MODULE': "procrement-file-invitation-approval-list", //邀请书及文件编制核验
  'GP_AUDIT_NOTICE_FILING_APPROVAL_MODULE': "procrement-file-review-approval-list", //资审公告及文件编制核验
  'GOVP_QUALIFICATION_AUDIT_APPROVAL': 'qualification-audit-approval-list', //资审文件核验
  'GOVP_QUALIFICATION_AUDIT_CORRECTION': 'qualification-audit-correction-list', //资审更正申请
  'GOVP_QUALIFICATION_AUDIT_NOTICE': 'qualification-audit-detail',
  'GOVP_PURCHASE_NOTICE_APPLY': 'notice-apply-list', //单一来源采购公示申请列表
  'GOVP_SINGLE_SOURCE_NOTICE_APPROVAL': 'single-source-notice-approval-list', //单一来源公示核验列表
  'GOVP_SINGLE_SOURCE_NOTICE': 'single-source-notice-main', //单一来源公示
  'GOVP_TENDER_PROJECT': 'project-list', //项目入场登记
  'GOVP_TENDER_PROJECT_NO_PALN': 'project-list-nodemand', //项目入场登记（无采购计划）
  'GOVP_TENDER_PROJECT_APPROVAL': 'project-approval-list', //项目入场登记核验
  'GOVP_PROJECT_CORRECTION': 'project-correction-list', //项目更正申请
  'GOVP_TENDER_PURCHASER_PROJECT_MANAGEMENT': 'purchaser-project-management-list', //我的采购项目
  'GOVP_TENDER_CARRY_OUT_NOTICE_ASSIGN_CONFIRM': 'carry-out-notice-assign-confirm-list', //执行通知书任务分派确认
  'GOVP_TENDER_ENPERT_APPLICATION': 'enpert-application-list', //专家抽取申请
  'GOVP_BID_DOCUMENT': 'bid-document-list', //标书下载及报名
  'GOVP_BID_JOINT': 'bid-joint-list', //组件联合体
  'GOVP_BID_QUESTION': 'question-list', //供应商质疑
  'GOVP_BID_ANSWER_CGR': 'answer-list', //采购人质疑回复
  'GOVP_SURVEY_RESULT_RECORD_CGR': 'survey-result-record-cgr-list', //采购人踏勘结果登记
  'GOVP_BID_REGISTER_MANAGE': 'register-manage-list', //我的投标项目管理
  'GOVP_PROJECT_ASSIGN': 'project-assign-list', //标中任务分派
  'GOVP_PROJECT_ASSIGN_CONFIRM': 'project-assign-confirm-list', //标中任务分派确认
  'GOVP_CONTRACT_PUBLICITY_VARIFICATION': 'contract-publicity-verification-list', //合同公示核验
  'GOVP_CONTRACT_PUBLICITY_CGR': 'contract-publicity-cgr-list', //合同公示列表页面
  'GOVP_TENDER_VENUE_BOOK': 'project-venue-book-venue', //预约场地
  'GP_MODULE_VENUE_BOOK': 'venue-book', //预约场地及变更
  'GP_TRANS_STATISTIC': 'transactionstatus-list', //交易情况统计
  'GP_MODULE_APPROVAL_VENUE_BOOK': 'venue-book-approval', //预约场地及变更核验
  'GP_MODULE_ZS_VENUE_BOOK': 'venue-book-review', //资审预约场地及变更
  'GP_MODULE_ZS_APPROVAL_VENUE_BOOK': 'venue-book-review-approval', //资审预约场地及变更核验
  'GOVP_RECOMMENDED_SUPPLIER': 'recommended-supplier-list', //采购人推荐供应商
  'GOVP_CONFIRM_WIN_BIDDER': 'confirm-win-bidder-list', //确定中标人
  'GOVP_WIN_BID_NOTICE_APPROVE': 'win-bid-announcement-approve-list', //中标结果公告核验
  'GOVP_EVALUATION_BID_RESULT_APPROVE': 'evaluation-bid-result-approve-list',//评审结果核验
  'GOVP_PURCHASE_DEMAND_NOTICE_APPROVAL': 'purchase-demand-notice-approval-list', //采购需求公示核验
  'GOVP_EXCEPTION_PROJECT_STOP': 'project-stop-list', //项目异常处理
  'GOVP_EXCEPTION_PURCHASER_PROJECT_STOP': 'purchaser-project-stop-list', //采购人发起的项目异常处理
  'GOVP_EXCEPTION_PROJECT_STOP_APPROVAL': 'project-stop-approval-list', //项目异常处理核验
  'GOVP_EXCEPTION_MANAGER_PROJECT_STOP_APPROVAL': 'manager-project-stop-approval-list', //项目负责人/采购代理--项目异常处理核验
  'GOVP_EXCEPTION_PROJECT_PAUSE': 'project-pause-resumed-list', //项目暂停处理
  'GOVP_PURCHASER_EXCEPTION_PROJECT_PAUSE': 'purchaser-project-pause-resumed-list', //项目暂停处理-采购人发起
  'GOVP_EXCEPTION_PROJECT_PAUSE_APPROVAL': 'project-pause-resumed-approval-list', //项目暂停核验处理
  'GP_MODULE_GUARANTEE_LETTER_RETURN': 'return-guarantee-list', //退还投标保函
  'GP_MODULE_GUARANTEE_LETTER_RETURN_VIEW': 'check-return-list', //查看退还
  'GP_MODULE_APPROVAL_GUARANTEE_LETTER_RETURN': "return-guarantee-approval-list", //退还投标保函核验
  'GOVP_EXCEPTION_MANAGER_PROJECT_PAUSE_APPROVAL': 'manager-project-pause-resumed-approval-list', //项目暂停核验处理--项目负责人/采购代理
  'GP_MODULE_GUARANTEE_LETTER_CLAIM': 'guarantee-letter-claim-list', //保函索赔申请列表

  'GP_MODULE_GUARANTEE_LETTER_CLAIM_APPROVE': 'guarantee-letter-claim-approval', //保函索赔申请列表

  'GOVP_WIN_BID_NOTICE_APPROVE_MODIFY': 'win-bid-notice-modify-approve-list', //标后结果更正核验
  'GP_MODULE_PROJECT_APPROVE_DYNAMIC_ASSIGN': 'project-approve-assign-list', //工作分派
  'GOVP_EVAL_REACCREDITATION_APPLY_APPROVAL': 'reaccreditation-apply-approval-list', //复评申请核验
  'GOVP_PROJECT_FILING': 'project-filing-list', //项目备案申请
  'GOVP_PROJECT_FILING_JGBM': 'project-filing-jgbmshow', //项目备案审阅
  'GOVP_PROJECT_FILING_CGR': 'project-filing-cgrshow', //项目备案审阅

  'GOVP_NULLIFIELD_BID_APPROVAL': 'nullifield-bid-approval-list', //废标公告核验
  'GOVP_PURCHASE_DEMAND_QUERY': 'purchase-demand-query-list', //采购需求询问

  'GOVP_CHANGE_JUDGE_APPLICATION_APPROVE': 'change-judge-application-approve-list', //变更评委申请核验

  'GOVP_PURCHASE_DEMAND_ANSWER': 'purchase-demand-answer-list', //采购需求答疑
  'GOVP_CHANGE_PURCHASER_MODE_APPROVE': 'change-purchaser-mode-approve-list', //变更采购方式核验

  'GOVP_IMPLEMENTATION': 'implementation-list', //履约登记
  'GOVP_ROLE_IMPLEMENTATION': 'implementation-role-list',
  'GOVP_MODULE_WIN_BID_NOTIFY': 'bid-notice-list', //查看中标通知书
  'GOVP_COMPLAINT': 'complaint-list', //投诉
  'GOVP_ONLINE_COMPLAINT': 'complaint-online-list', //在线投诉
  'GB_MODULE_CONTRACT_CHECK': 'organization-check',//在线合同核验
  'GB_MODULE_CONTRACT_EDIT': 'organization',//合同编制
  'GB_MODULE_CONTRACT_CONFIRM': 'sign-contracts-online/sure',
  'GB_MODULE_CONTRACT_VIEW': 'find',
  'GB_MODULE_CONTRACT_VIEWS': 'sign-contracts-online/find',
  'GOVP_MODIFY_NOTICE_APPROVE': 'modify-notice-approve-list', //信息更正公告核验
  'GOVP_QUALIFICATION_AUDIT_MODIFY_APPROVE': 'qualification-audit-modify-notice-approve-list', //资审更正公告核验

  'GOVP_PROJECT_OVERVIEW': 'project-overview-list', //项目进程总览

  'GOVP_COMPLAINT_ANSWER': 'complaint-answer-list', //投诉

  'GOVP_PROJECT_FILED_CHECK': 'project-filed-list', //项目归档查阅个人项目
  'GOVP_PROJECT_FILED_CHECK_ALL': 'project-filed-list-all', //项目归档查阅所有项目
  'GOVP_PROJECT_FILED': 'project-filed-main', //新项目归档

  'GOVP_ENROLL_VIEW_LEADER': 'enroll-view-leader-list', //查看报名情况-领导
  'TO_DO_STATISTICS': 'todo-statistics', //代办事项
  'WORK_ASSIGN': 'work-assign', //工作分派
  'GOVP_COLLECTION_VERIFY_CHECK': 'purchase-file-verification-list', //项目扩展-采购文件核验
  'GOVP_QUALIFICATION_VERIFY_CHECK': 'information-file-verification-list', //资审文件核验
  'WIN-BID-INVALID-NOTICE-APPROVAL': 'verification-list', //资审文件核验
  'GOVP_TENDER_PROJECT_EXTEND_CODE': 'purchaser-project-list',//采购人项目入场登记
  'GOVP_PROJECT_PRINCIPAL': 'distribution-list-principal', //部长项目入场分配项目负责人
  'GOVP_PROJECT_PRINCIPAL_APPROVAL': 'distribution-list-principal-approval', //部长项目入场核验
  'GOVP_PROJECT_PRINCIPAL_CONFIRM': 'distribution-list-principal-confirm', //项目负责人确认
  'GOVP_PROJECT_INFO_VIEW': 'project-info-view-list', //项目信息查看列表
  'GOVP_AUTHORIZATION_ENTRUST_BOOK_MODULE_CODE': 'authorization-entrust-book-list', //授权委托书
  'GOVP_BID_ANSWER_REPLY': 'answer-reply-approval-list', //质疑答复核验
  'GP_SHFRLHJC_MODEL': 'shfrlhjc-model' ,//奖惩系统数据拦截
  'GOVP_WIN_BID_ANNOUNCEMENT_MODIFY_EXTEND_MODULE_CODE': 'win-bid-announcement-modify-list', //标后变更中标人
  'GOVP_PERFORMANCE_CODE': 'perforance-guarantee',//供应商履约保函
  'GOVP_PERFORMANCE_APPLY_CODE': "tenderee-guarantee",//招标人履约保函
  'GOVP_ANSWER_ANNOUNCEMENT_MODULE_CODE': "answer-publicity",//质疑公示
  'GOVP_ANSWER_ANNOUNCEMENT_APPROVAL_MODULE_CODE':"answer-publicity-check",//质疑公示核验
  'GOVP_CONTRACT_PAY_MODULE_CODE':'pay-supplier-list',//支付信息查看
  'GP_MODULE_VENUE_SYSTEM':'sso', //跳转到G2交易系统（场地）
  'GOVP_INQUIRY_INITIATE_MODULE_CODE': 'answer-query', //质疑询问
  'GOVP_INQUIRY_ANSWER_MODULE_CODE':'answer-reply-list', //回复质疑询问
  'GOVP_INQUIRY_INITIATE_MODULE_CHECK': 'answer-query-check',//质疑询问核验
  'GOVP_CONTRACT_PAY_APPLY_MODULE_CODE':"pay-apply",//支付申请
  'GP_STATISTICS_ANALYSIS_MODULE': 'statistics-analysis/index', //统计分析
}

//菜单和子系统的code映射在此处配置
export const routerMenuMap = {
  'GOVP_TENDER_PURCHASEDEMAND': 'purchase-demand-list', //采购需求编制
  "GOVP_MODULE_BIDIRECTEVALUATION_EDIT": 'interested-parties',//相关方互评
  'GOVP_PURCHASE_DEMAND_NOTICE': 'purchase-demand-notice-list', //采购需求公示编制
  'GOVP_TENDER_CARRY_OUT_NOTICE': 'carry-out-notice-list', //执行通知书管理
  'GOVP_TENDER_CARRY_OUT_NOTICE_ACCEPTANCE': 'carry-out-notice-acceptance-list', //执行通知书受理
  'GOVP_TENDER_CARRY_OUT_NOTICE_ASSIGN': 'carry-out-notice-assign-list', //执行通知书任务分派
  'GOVP_TENDER_CARRY_OUT_NOTICE_DE_ASSIGN': 'carry-out-notice-de-assign-list', //执行通知书任务分派
  'GOVP_PROJECT_DISTRIBUTION': 'distribution-list', //执行通知书任务分派
  'GOVP_TENDER_CARRY_OUT_NOTICE_READ': 'carry-out-notice-read-list', //采购计划查阅
  'GOVP_TENDER_PURCHASEDEMAND_CONFIRM': 'purchase-demand-confirm-list', //采购需求确认
  'GOVP_PROCREMENT_FILE_APPROVAL': 'procrement-file-approval-list', //产品的-采购公告及文件核验
  'GOVP_COLLECTION_VERIFY_CHECK': 'purchase-file-verification-list', //项目扩展-采购文件核验
  'GOVP_RECOMMENDED_SUPPLIER': 'recommended-supplier-list', //采购人推荐供应商
  'GOVP_QUALIFICATION_AUDIT_APPROVAL': 'qualification-audit-approval-list', //资审文件核验
  'GOVP_QUALIFICATION_AUDIT_CORRECTION': 'qualification-audit-correction-list', //资审更正申请
  'GOVP_TENDER_PROJECT': 'project-list', //项目入场登记
  'GOVP_TENDER_PROJECT_NO_PALN': 'project-list-nodemand', //项目入场登记（无采购需求）
  'GOVP_TENDER_PROJECT_APPROVAL': 'project-approval-list', //项目入场登记核验
  'GOVP_PROJECT_CORRECTION': 'project-correction-list', //项目更正申请
  'GOVP_SINGLE_SOURCE_NOTICE': 'single-source-notice-main', //单一来源公示
  'GOVP_PURCHASE_NOTICE_APPLY': 'notice-apply-list', //单一来源采购公示申请列表
  'GOVP_SINGLE_SOURCE_NOTICE_APPROVAL': 'single-source-notice-approval-list', //单一来源公示核验列表
  'GOVP_TENDER_PURCHASER_PROJECT_MANAGEMENT': 'purchaser-project-management-list', //我的采购项目
  'GOVP_TENDER_CARRY_OUT_NOTICE_ASSIGN_CONFIRM': 'carry-out-notice-assign-confirm-list', //执行通知书任务分派确认
  'GOVP_TENDER_ENPERT_APPLICATION': 'enpert-application-list', //专家抽取申请
  'GOVP_BID_DOCUMENT': 'bid-document-list', //标书下载及报名
  'GOVP_BID_JOINT': 'bid-joint-list', //组件联合体
  'GOVP_BID_QUESTION': 'question-list', //供应商质疑
  'GOVP_BID_ANSWER_CGR': 'answer-list', //采购人质疑回复
  'GOVP_SURVEY_RESULT_RECORD_CGR': 'survey-result-record-cgr-list', //采购人踏勘结果登记
  'GOVP_BID_REGISTER_MANAGE': 'register-manage-list', //我的投标项目管理
  'GOVP_PROJECT_ASSIGN': 'project-assign-list', //标中任务分派
  'GOVP_PROJECT_ASSIGN_CONFIRM': 'project-assign-confirm-list', //标中任务分派确认
  'GOVP_CONTRACT_PUBLICITY_VARIFICATION': 'contract-publicity-verification-list', //合同公示核验
  // 'GOVP_CONTRACT_PUBLICITY':'contract-publicity-cgr-list',//合同公示列表页面
  'GOVP_TENDER_VENUE_BOOK': 'project-venue-book-venue', //预约场地
  'GP_MODULE_VENUE_BOOK': 'venue-book', //预约场地及变更
  'GP_MODULE_APPROVAL_VENUE_BOOK': 'venue-book-approval', //预约场地及变更核验
  'GP_TRANS_STATISTIC': 'transactionstatus-list', //交易情况统计
  'GP_MODULE_ZS_VENUE_BOOK': 'venue-book-review', //资审预约场地及变更
  'GP_MODULE_ZS_APPROVAL_VENUE_BOOK': 'venue-book-review-approval', //资审预约场地及变更核验
  'GOVP_CONFIRM_WIN_BIDDER': 'confirm-win-bidder-list', //确定中标人
  'GOVP_WIN_BID_NOTICE_APPROVE': 'win-bid-announcement-approve-list', //中标结果公告核验
  'GOVP_EVALUATION_BID_RESULT_APPROVE': 'evaluation-bid-result-approve-list',//评审结果核验
  'GOVP_PURCHASE_DEMAND_NOTICE_APPROVAL': 'purchase-demand-notice-approval-list', //采购需求公示核验
  'GOVP_EXCEPTION_PROJECT_STOP': 'project-stop-list', //项目异常处理
  'GOVP_EXCEPTION_PURCHASER_PROJECT_STOP': 'purchaser-project-stop-list', //采购人发起的项目异常处理
  'GOVP_EXCEPTION_PROJECT_STOP_APPROVAL': 'project-stop-approval-list', //项目异常处理核验
  'GOVP_EXCEPTION_MANAGER_PROJECT_STOP_APPROVAL': 'manager-project-stop-approval-list', //项目负责人/采购代理--项目异常处理核验
  'GOVP_EXCEPTION_PROJECT_PAUSE': 'project-pause-resumed-list', //项目暂停处理
  'GOVP_EXCEPTION_PROJECT_PAUSE_APPROVAL': 'project-pause-resumed-approval-list', //项目暂停核验处理
  'GP_MODULE_GUARANTEE_LETTER_RETURN': 'return-guarantee-list', //退还投标保函
  'GP_MODULE_GUARANTEE_LETTER_RETURN_VIEW': 'check-return-list', //查看退还
  'GP_MODULE_APPROVAL_GUARANTEE_LETTER_RETURN': "return-guarantee-approval-list", //退还投标保函核验
  'GOVP_EXCEPTION_MANAGER_PROJECT_PAUSE_APPROVAL': 'manager-project-pause-resumed-approval-list', //项目暂停核验处理--项目负责人/采购代理
  'GOVP_WIN_BID_NOTICE_APPROVE_MODIFY': 'win-bid-notice-modify-approve-list', //标后结果更正核验
  'GP_MODULE_PROJECT_APPROVE_DYNAMIC_ASSIGN': 'project-approve-assign-list', //工作分派
  'GOVP_EVAL_REACCREDITATION_APPLY_APPROVAL': 'reaccreditation-apply-approval-list', //复评申请核验
  'GOVP_PROJECT_FILING': 'project-filing-list', //项目备案申请
  'GOVP_PROJECT_FILING_JGBM': 'project-filing-jgbmshow', //项目备案审阅
  'GOVP_PROJECT_FILING_CGR': 'project-filing-cgrshow', //项目备案审阅

  'GOVP_NULLIFIELD_BID_APPROVAL': 'nullifield-bid-approval-list', //废标公告核验
  'GOVP_PURCHASE_DEMAND_QUERY': 'purchase-demand-query-list', //采购需求询问

  'GOVP_CHANGE_JUDGE_APPLICATION_APPROVE': 'change-judge-application-approve-list', //变更评委申请核验

  'GOVP_PURCHASE_DEMAND_ANSWER': 'purchase-demand-answer-list', //采购需求答疑
  'GOVP_CHANGE_PURCHASER_MODE_APPROVE': 'change-purchaser-mode-approve-list', //变更采购方式核验

  'GOVP_IMPLEMENTATION': 'implementation-list', //履约登记
  'GOVP_COMPLAINT': 'complaint-list', //投诉
  'GOVP_ONLINE_COMPLAINT': 'complaint-online-list', //在线投诉
  'GB_MODULE_CONTRACT_EDIT': 'organization-check',//在线合同核验
  'GOVP_MODIFY_NOTICE_APPROVE': 'modify-notice-approve-list', //信息更正公告核验
  'GOVP_QUALIFICATION_AUDIT_MODIFY_APPROVE': 'qualification-audit-modify-notice-approve-list', //资审更正公告核验
  'GOVP_PROJECT_OVERVIEW': 'project-overview-list', //项目进程总览

  'GOVP_COMPLAINT_ANSWER': 'complaint-answer-list', //投诉

  'GOVP_PROJECT_FILED_CHECK': 'project-filed-list', //项目归档
  'TO_DO_STATISTICS': 'todo-statistics', //代办事项
  'WORK_ASSIGN': 'work-assign' //工作分派
}
export const routerSysMap = {
  'ZFCG': '/zfcg/#/index', //政府采购 
  'G3_GFM': 'naturalperson-edit', //企业库
  'GRGZT': '/workbench/#/personaylWorkbench',
  'ZXBB': process.env.ZXBB_API_HOST,
  // 'YCYDKB': 'http://10.0.197.145:81/'
}
//系统禁用不显示黑名单
export const sysListDisabled = [
  'tender'
]



// WEBPACK FOOTER //
// ./src/router/router-code.js